import { NavigationPathsEnum } from "@utilities/enums";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useNavigation = () => {

  const navigate = useNavigate();

  const navigateTo = useCallback(
    (link: NavigationPathsEnum, state?: object) => {

      return navigate(link, { state });
    }, [navigate]);

  const goBack = useCallback(() => navigate(-1), [navigate]);

  return {
    navigateTo,
    goBack
  };
};
